/**
 * Copy both AMS pages share — AMS View and Review AMS Data — for the pieces in
 * `components/Ams/shared/`: the write lock, Amazon links, the store and brand
 * pickers, the date presets and the number formats. VentaHub's English,
 * verbatim where VentaHub had it.
 */
export const amsShared = {
  lock: {
    // AmazonWriteLockBanner.tsx:63
    title: 'Writes to Amazon are locked',
    // AmazonWriteLockBanner.tsx:71, with the backend's reason in front.
    body: '{{reason}} Data still loads; edits will be refused.',
    defaultReason: 'VentaWiz does not send changes to Amazon Ads yet.',
    // utils/amazonWriteLock.ts:31, for a 423 that carries no message.
    toastFallback:
      'Writes to Amazon are disabled. VentaWiz does not send changes to Amazon Ads yet.',
    editAccess: 'You need edit access to Ads to make changes.',
  },
  // components/common/AmazonLinkCell.tsx:50-57
  amazonLink: {
    product: 'Open on Amazon',
    search: 'Search on Amazon',
  },
  // hooks/useAdGroupCounts.tsx:76-112
  adGroupCounts: {
    enabled_one: '{{count}} enabled',
    enabled_other: '{{count}} enabled',
    paused_one: '{{count}} paused',
    paused_other: '{{count}} paused',
    none: 'No AdGroups',
  },
  // components/StoreDropdown.tsx:421-487, AmsViewPage.tsx:2027
  stores: {
    label: 'Store',
    pick: 'Select stores',
    all: 'All stores ({{count}})',
    someOf_one: '{{picked}} of {{count}} store',
    someOf_other: '{{picked}} of {{count}} stores',
  },
  // AmsViewPage.tsx:1842-1844, 2108-2133; ReviewAmsDataPage.tsx:508-547
  brands: {
    label: 'Brands',
    unbranded: 'Unbranded',
    all: 'All brands ({{count}})',
    allWithUnbranded: 'All brands ({{count}}) + unbranded',
    someOf_one: '{{picked}} of {{count}} brand',
    someOf_other: '{{picked}} of {{count}} brands',
    none: 'No brands',
  },
  // AmsViewPage.tsx:1820-1832; ReviewAmsDataPage.tsx:212-225
  datePresets: {
    last7: 'Last 7 days',
    last14: 'Last 14 days',
    last30: 'Last 30 days',
    last60: 'Last 60 days',
    last90: 'Last 90 days',
    monthToDate: 'Month to date',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    yearToDate: 'Year to date',
  },
  format: {
    // ROAS and multipliers: "2.50×".
    times: '{{value}}×',
    // A change in a percentage: "+1.25 pp".
    pp: '{{value}} pp',
    // VentaHub's EMPTY_METRIC: a figure that does not exist (no units, no ASP).
    empty: '—',
  },
} as const
